<app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>

<mat-card>
    <mat-card-content>
      <mat-card-title style="font-weight:bold;color:#009687">Ultimo avviso:</mat-card-title>
      <div *ngIf="!announcements"><h2>Nessun avviso pubblicato.</h2></div>
            <ng-container *ngFor="let ann of announcements; index as i">
        <ng-container *ngIf="i==0">
          
          <mat-card id="element-announcements">
            <mat-card-title id="title-announcement-first">Dal dott. {{ann.doctorName}} {{ann.doctorSurname}}</mat-card-title>
            <mat-card-subtitle style="color:black">Data : {{ann.giorno}}-{{ann.mese}}-{{ann.anno}}</mat-card-subtitle>
            <mat-card-content>
                {{ann.text}}
            </mat-card-content></mat-card>
  
        </ng-container>
        <ng-container *ngIf="i!=0">
          <ng-container *ngIf="i==1"><h3>Vecchi avvisi:</h3></ng-container>
          <mat-card class="element-announcements">
            <mat-card-title>Dal dott. {{ann.doctorName}} {{ann.doctorSurname}}</mat-card-title>
            <mat-card-subtitle>Data : {{ann.giorno}}-{{ann.mese}}-{{ann.anno}}</mat-card-subtitle>
            <mat-card-content>
                {{ann.text}}
            </mat-card-content></mat-card>
  
        </ng-container>
      
                
            </ng-container>
        </mat-card-content>
      </mat-card>
      